import axios from 'axios';
const header = {
  'Content-Type': 'application/json',
}

/*****************************First Fetched Masked Email and Mobile**************************** */
export const getMaskedPhoneAndEmail = async (activityId, eventCode, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_MASK_PHONE_AND_EMAIL_API,
        "activityid": `${activityId}`,
        "coapplicant": `${coapplicant}`,
        "eventcode": `${eventCode}`
      },
      "orgId": process.env.REACT_APP_ORGID,//uat
      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config)
}
/************************************************************************************************ */


export const sendOtpToMobileNumber = async (activityId, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": "da_53450_e1a4c381",//prod
        "type": "sendMobileOTP"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityId: activityId,
          applicantType: coapplicant,
          type: 'consent'
        }
      }
    })
  }
  return await axios(config);
}

export const verifyOtpFromApi = async (activityId, coapplicant, otp) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": "da_53450_e1a4c381",//prod
        "type": "verifyMobileOTP"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityId: activityId,
          applicantType: coapplicant,
          type: 'consent',
          otp: otp,
        }
      }
    })
  }

  return await axios(config);
}


export const getLeadDetailsByIdAndCoApplicantId = async (
  leadId,
  activityId,
  eventCode,
  coapplicant,
  token,
  applicantType
) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_LANDING_PAGE_API,
        "leadid": `${leadId}`,
        "activityid": `${activityId}`,
        "eventcode": `${eventCode}`,
        "coapplicant": `${coapplicant}`,
        "eventType": "fetchLeadDetails",

      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          "tokenDetails": {
            token: `${token}`,
            activityId: `${activityId}`,
            coApplicant: `${applicantType}`,
            type: 'consent',

          }
        }
      }
    })
  }
  return await axios(config);
}


export const logVerificationResponse = async (activityId, coapplicant, eventcode, leadId, status, applicantType, token) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_LANDING_PAGE_API,

        "eventType": "logVerificationDetails",
        "otpStatus": `${status}`
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          leadId: leadId,
          "tokenDetails": {
            token: `${token}`,
            activityId: `${activityId}`,
            coApplicant: `${applicantType}`,
            type: 'consent',

          }
        }
      }
    })
  }
  return await axios(config);
}

export const acceptConsentApi = async (body, info, token, applicantType) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_LANDING_PAGE_API, //uat

        "eventType": "acceptconsent"
      },
      "orgId": process.env.REACT_APP_ORGID,//uat

      "data": {
        "lappBody": {
          activityid: body?.activityId,
          coapplicant: body?.coapplicant,
          eventcode: body?.eventcode,
          leadId: body?.leadId,
          consentInformation: info,
          "tokenDetails": {
            token: `${token}`,
            activityId: `${body?.activityId}`,
            coApplicant: `${applicantType}`,
            type: 'consent',

          }
        },
      }
    })
  }
  return await axios(config);
}

export const consentPostProcessApi = async (body, info, token, applicantType) => {
  console.log("Consent Post processing..");
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_LANDING_PAGE_API,
        "eventType": "consentPostProcess",
        "compressrequestbody": "1"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityid: body?.activityId,
          coapplicant: body?.coapplicant,
          eventcode: body?.eventcode,
          leadId: body?.leadId,
          consentInformation: info,
          "tokenDetails": {
            token: `${token}`,
            activityId: `${body?.activityId}`,
            coApplicant: `${applicantType}`,
            type: 'consent',
          }
        },
      }
    })
  }

  return await axios(config);
}

//parellel api call
export const consentCreatePostProcessApi = async (body, info, mobileOtp, applicantType) => {
  const config = await Promise.all([acceptConsentApi(body, info, mobileOtp, applicantType), consentPostProcessApi(body, info, mobileOtp, applicantType)]);
  return config;
}



